import React from "react";
import { Card, CardBody } from "reactstrap";

// Card exibido nos Portais quando o requerimento foi reprovado pelo gestor (status "Divergente").
// Mostra o motivo da análise mais recente e a orientação para reenviar o requerimento à análise (CE-4367).
// O órgão analisador vem de setupSistema.identificacao (multi-tenant): em São Paulo, "SP Regula".
const CardRejeicaoRequerimento = ({
  requerimento,
  setupSistema,
  tituloClassName = "text-danger",
}) => {
  const analises = requerimento?.requerimentoAnaliseGestor ?? [];

  if (requerimento?.status !== "Divergente" || analises.length === 0) return null;

  const ultimaAnalise = [...analises].sort(
    (a, b) => new Date(b.dataAnalise) - new Date(a.dataAnalise)
  )[0];

  return (
    <Card className="card-stats">
      <CardBody>
        <h5 className={tituloClassName}>
          Seu requerimento foi rejeitado por {setupSistema?.identificacao}.
          Verifique as informações abaixo e corrija os dados necessários.
        </h5>
        <p>{ultimaAnalise.observacao}</p>
        <p className="mb-0">
          <strong>Importante:</strong> Prezado(a), após realizar as alterações
          solicitadas, é necessário avançar por todas as etapas do requerimento
          e, na etapa <strong>Documentos</strong>, clicar em{" "}
          <strong>Concluir</strong> para salvar e encaminhar o requerimento para
          uma nova análise da {setupSistema?.identificacao}. Caso não execute a conclusão, o
          requerimento não será enviado para nova análise.
        </p>
      </CardBody>
    </Card>
  );
};

export default CardRejeicaoRequerimento;
